import "react/jsx-runtime";
import "styled-components";
import { useThemeInMode as i } from "../../../../context/theme/hooks.js";
import { HOVER_OVERLAY_OPACITY as C, ACTIVE_OVERLAY_OPACITY as g } from "../../../../styles/colors/consts.js";
import l from "../../../../styles/colors/surfaces/useStateColor.js";
import n from "../../../../utils/colorWithOpacity/index.js";
function b({
  fill: e,
  tone: c,
  disabled: t
}) {
  const r = i();
  let o;
  e === "outlined" ? o = {
    backgroundColor: `${c}-high-content`,
    color: `${c}-high-content`
  } : e === "filled" ? o = {
    backgroundColor: `${c}-high-surface`,
    color: `contentOn-${c}-high-surface`
  } : o = {
    backgroundColor: `${c}-medium-surface`,
    color: `${c}-high-content`
  };
  const u = l(r[o.backgroundColor], "hover"), a = l(r[o.backgroundColor], "active");
  return e === "outlined" ? {
    backgroundColor: "transparent",
    color: r[o.color],
    hoverStyles: t ? void 0 : {
      backgroundColor: n(
        r[o.backgroundColor],
        C
      )
    },
    activeStyles: t ? void 0 : {
      backgroundColor: n(
        r[o.backgroundColor],
        g
      )
    }
  } : {
    backgroundColor: r[o.backgroundColor],
    color: r[o.color],
    hoverStyles: t ? void 0 : {
      backgroundColor: u
    },
    activeStyles: t ? void 0 : {
      backgroundColor: a
    }
  };
}
export {
  b as default
};
